import { StarFour, VideoCamera } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Alert, Flex, Modal, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";

export const StoryboardApprovalModal = ({
  isOpen,
  handleOk,
  handleCancel,
  saving = false,
  estimatedGenerationTime,
}: {
  isOpen: boolean;
  handleOk: () => Promise<void>;
  handleCancel: () => void;
  saving?: boolean;
  estimatedGenerationTime?: string;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <Modal
      title={t("components.storyboard.StoryboardEditor.storyboardApproval")}
      open={isOpen}
      onOk={() => {
        handleOk().catch((e) => {
          console.error(e);
        });
      }}
      onCancel={handleCancel}
      okText={t("buttons.ok")}
      cancelText={t("buttons.cancel")}
      centered
      closable={false}
      okButtonProps={{
        size: "large",
        shape: "round",
        disabled: saving,
        loading: saving,
      }}
      cancelButtonProps={{ size: "large", shape: "round" }}
    >
      <Flex vertical gap={0} justify="center" align="center">
        <div
          style={{
            marginRight: 10,
            marginTop: 5,
            position: "relative",
          }}
        >
          <VideoCamera size={100} weight="duotone" color={theme.colorPrimary} />
          <StarFour
            weight="fill"
            size={30}
            style={{
              position: "absolute",
              top: 0,
              left: 100,
            }}
            color={theme.colorPrimary}
          />
        </div>
        {estimatedGenerationTime && (
          <Typography.Text style={{ textAlign: "center" }}>
            {t("components.storyboard.StoryboardEditor.validation", {
              estimatedGenerationTime,
            })}
          </Typography.Text>
        )}
        <Alert
          description={t("components.storyboard.StoryboardEditor.warning")}
          showIcon
          type="warning"
          style={{
            marginTop: 30,
            marginBottom: 10,
            width: "100%",
          }}
        />
      </Flex>
    </Modal>
  );
};
